import EventBus from "eventing-bus"
import gsap from "gsap"
import {
  constants,
  getCurrSection,
  getPrevSection,
  getModelsArr,
  getWheelModelsArr,
  getIsEndBoardZoomed,
  getCurrBoard,
  getCurrWheel,
} from "../model"

const THIS_SECTION_NUM = 2

let tempWheelsArr = [],
  currBoard = null,
  truckAddedToGroup = false

/**
 * Event handlers
 */

const handleSectionChanged = () => {
  // If going from 2 to 1, clear wheels
  if (
    (getPrevSection() === 2 && getCurrSection() === 1) ||
    (getPrevSection() === 2 && getCurrSection() === 0) ||
    (getPrevSection() === 3 && getCurrSection() === 2) ||
    (getPrevSection() === 3 && getCurrSection() === 1) ||
    (getPrevSection() === 3 && getCurrSection() === 0)
  ) {
    truckAddedToGroup = false
    tempWheelsArr.map((d, i) => {
      currBoard.remove(d)
    })
  }
  if (getCurrSection() === 3) {
    if (!truckAddedToGroup) {
      buildWheels()
      animateWheels()
    }
    truckAddedToGroup = true
  }
  if (getCurrSection() === THIS_SECTION_NUM) {
    setTimeout(() => {
      truckAddedToGroup = true
      buildWheels()
      animateWheels()
    }, 1600)
  }
}

const handleWheelChanged = () => {
  setTimeout(() => {
    changeWheels()
  }, 800)
}
const handleProductZoom = () => {
  if (getIsEndBoardZoomed()) {
    setTimeout(() => {
      spinWheels()
    }, 3000)
  }
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
EventBus.on(constants.PLAY_PRODUCT_ZOOM, handleProductZoom)
EventBus.on(constants.WHEEL_CHANGED, handleWheelChanged)

/**
 * Fn
 */

const changeWheels = () => {
  tempWheelsArr.map((d) => {
    d.visible = false
    currBoard.remove(d)
  })

  buildWheels()
  animateWheels()
}

const buildWheels = () => {
  let wheelModel = getWheelModelsArr()[getCurrWheel()].model,
    copy1 = wheelModel.clone(),
    copy2 = wheelModel.clone(),
    copy3 = wheelModel.clone()

  currBoard = ""
  currBoard = getModelsArr()[getCurrBoard()].group
  tempWheelsArr = []
  tempWheelsArr = [wheelModel, copy1, copy2, copy3]
  tempWheelsArr.map((d, i) => (d.visible = false))
  currBoard.add(wheelModel)
  currBoard.add(copy1)
  currBoard.add(copy2)
  currBoard.add(copy3)
}

const animateWheels = () => {
  const wheelModel = tempWheelsArr[0],
    copy1 = tempWheelsArr[1],
    copy2 = tempWheelsArr[2],
    copy3 = tempWheelsArr[3],
    duration = 1.6,
    wheelAnimDistance = 6,
    x = 1.035,
    y = 3.1,
    z = 0.73

  gsap.set(wheelModel.position, { x, y: 2.584, z })
  gsap.from(wheelModel.position, {
    onStart: () => (wheelModel.visible = true),
    duration,
    x: wheelAnimDistance,
    delay: 0.6,
    ease: "power4.out",
  })

  gsap.set(copy1.position, { x, y: -2.694, z })
  gsap.from(copy1.position, {
    onStart: () => (copy1.visible = true),
    duration,
    x: wheelAnimDistance,
    delay: 0,
    ease: "power4.out",
  })

  gsap.set(copy2.position, { x: -x, y: 2.584, z: 0.72 })
  gsap.set(copy2.rotation, { y: Math.PI })
  gsap.from(copy2.position, {
    onStart: () => (copy2.visible = true),
    duration,
    x: -wheelAnimDistance,
    delay: 0.4,
    ease: "power4.out",
  })

  gsap.set(copy3.position, { x: -x, y: -2.696, z: 0.72 })
  gsap.set(copy3.rotation, { y: Math.PI })
  gsap.from(copy3.position, {
    onStart: () => (copy3.visible = true),
    duration,
    x: -wheelAnimDistance,
    delay: 0.2,
    ease: "power4.out",
  })

  setTimeout(() => {
    spinWheels()
  }, 1700)
}
const spinWheels = () => {
  tempWheelsArr.map((wheel, i) => {
    const d = wheel.getObjectByName("Wheel"),
      currRotationX = d.rotation.x,
      duration = getCurrSection() === 3 ? 10 : 5

    let newRotationX = null,
      finalRotationRestingX = null

    if (i === 0 || i === 1) {
      newRotationX = currRotationX + 19
      finalRotationRestingX = newRotationX - 0.1
    }
    if (i === 2 || i === 3) {
      newRotationX = currRotationX - 19
      finalRotationRestingX = newRotationX + 0.1
    }

    gsap.to(d.rotation, {
      duration,
      x: newRotationX,
      ease: "power3.inOut",
      onComplete: () => {
        gsap.to(d.rotation, { duration: 4, x: finalRotationRestingX, ease: "power1.inOut" })
      },
    })
  })
}
